import { InputAdornment, Stack, Typography } from '@mui/material'
import { observer } from 'mobx-react-lite'
import PhoneCodes from './PhoneCodes.json'
import { useEffect, useRef, useState } from 'react'
import storeCountry from 'GlobalStores/Cores/County/StoreCountry'
import { useTranslate } from 'GlobalStores/Cores/Translator/useTranslate'
import { get } from 'lodash'
import { DefaultLabelTypo } from '../InputsStyled'
import mobiscroll from '@mobiscroll/react'
import { ReactComponent as DropdownIcon } from '../Assets/miniDropDown.svg'
import storeCheckout from 'GlobalStores/Checkout/StoreCheckout'
import UAECountryData from './UAECountryData.json'
import StoreTranslate from 'GlobalStores/Cores/Translator/StoreTranslate'
import styled from '@emotion/styled'
import DefaultInput from '../DefaultInput'
import './mobiscrollNumber.css'
import { autorun } from 'mobx'

const Wrapper = styled.div`
    width: 25px;
    display: flex;
`

const FlagImage = styled.img`
    // width: 30px;
    height: 15px;

    &.border-header {
        border-radius: 3px;
    }
`
const Flag = observer(props => {
    return (
        <Wrapper>
            <FlagImage className={props.type ? 'border-header' : ''} src={require(`./countriesSVG/${props.flag.toLowerCase()}.svg`)} />
        </Wrapper>
    )
})

const DefaultInputStyled = styled(DefaultInput)`
    width: 100%;

    .MuiOutlinedInput-root {
        border: 1px solid rgba(153, 188, 223, 0.25);
        border-radius: 6px;
        height: 50px;
        width: 100%;

        .MuiInputBase-input {
            font-size: 14px;
            font-weight: 400;
            color: #153862;
            height: 50px;
            box-sizing: border-box;
        }
    }

    .MuiOutlinedInput-notchedOutline {
        display: none;
    }
`

const MiddleEastAsiaPhoneInput = observer(({ formItem, dialCode, onChange }) => {
    const translate = useTranslate()
    const [flag, setFlag] = useState('')
    const [valueOptions, setValueOptions] = useState([])

    const saudiarabiaPhoneCodes = PhoneCodes.filter(item => item.code === 'SA')
    const phoneCodes = saudiarabiaPhoneCodes.map(item => {
        return {
            flag: item.code,
            countryName: item.name,
            options: `${item.dial_code} ${item.name}`,
            dial_code: item.dial_code
        }
    })

    const renderLists = phoneCodes.map(item => {
        return {
            text: item.options,
            value: item.countryName
        }
    })

    useEffect(() => {
        autorun(disposer => {
            if (storeCheckout.dialCode.length === 0 && !dialCode) {
                const defaultValueOptions = phoneCodes.find(item => item.flag === storeCountry.Country2())
                if (defaultValueOptions) {
                    storeCheckout.dialCode = defaultValueOptions.dial_code
                }
                disposer.dispose()
            } else if (dialCode) {
                storeCheckout.dialCode = dialCode
                disposer.dispose()
            }
        })
    }, [])

    useEffect(() => {
        if (dialCode) {
            const defaultValueOptions = phoneCodes.find(item => item.dial_code === dialCode)

            if (defaultValueOptions) {
                setFlag(defaultValueOptions.flag)
                setValueOptions(defaultValueOptions.options)
                storeCheckout.dialCode = defaultValueOptions.dial_code
            }
        } else {
            const defaultValueOptions = phoneCodes.find(item => item.flag === storeCountry.Country2())

            if (defaultValueOptions) {
                setFlag(defaultValueOptions.flag)
                setValueOptions(defaultValueOptions.options)
                storeCheckout.dialCode = defaultValueOptions.dial_code
            }
        }
    }, [dialCode])

    const uaeAreaCountries = country => {
        console.log(country)
        return UAECountryData.find(item => item.name === country || item.native_name === country || item.country2 === country || item.country === country)
    }

    const onSelected = (e, inst) => {
        const valueSelected = e.valueText

        const data = phoneCodes.find(item => item.options === valueSelected)

        if (UAECountryData.find(item => item.name === data.countryName)) {
            const uaeCountryObj = uaeAreaCountries(data.countryName)

            const countryName = get(uaeCountryObj, StoreTranslate.IsEnglish() ? 'name' : 'native_name', '')
            storeCheckout.SetCheckoutFormValue('country', countryName)
        }

        setValueOptions(data)
        setFlag(data.flag)
        storeCheckout.dialCode = data.dial_code
    }

    const selectRef = useRef(null)

    return (
        <Stack>
            <Stack>
                <DefaultLabelTypo variant="label" sx={{ color: 'rgba(21, 56, 98, 0.5)' }} mb="8px" pl="16px">
                    {translate(get(formItem, 'key', ''))}
                </DefaultLabelTypo>
            </Stack>
            <Stack flexDirection={'row'} gap={'15px'}>
                {/* <Stack
                    width={'90px'}
                    sx={{
                        label: { height: '100%', marginBottom: '0px', border: '1px solid rgba(153, 188, 223, 0.25)', borderRadius: '6px' },
                        svg: { cursor: 'default' }
                    }}
                    className="mobi-custom-phone-input">
                    <mobiscroll.Select
                        ref={selectRef}
                        className={formItem.key}
                        key={formItem.key}
                        display="center"
                        touchUi={false}
                        filter={true}
                        height={40}
                        maxWidth={400}
                        data={renderLists}
                        defaultSelection={valueOptions.countryName}
                        onSet={(e, inst) => onSelected(e, inst)}
                        value={valueOptions.countryName}
                        filterPlaceholderText=""
                        group={{
                            groupWheel: false,
                            header: false
                        }}
                        disabled
                        showInput={false}>
                        <mobiscroll.Input>
                            <Stack
                                sx={{
                                    position: 'absolute',
                                    flexDirection: 'row',
                                    transform: 'translate(-50%, -50%)',
                                    top: '50%',
                                    left: '50%',
                                    gap: '10px',
                                    alignItems: 'center',
                                    zIndex: 99
                                }}
                                onClick={() => {
                                    if (selectRef.current) {
                                        selectRef.current.instance.show()
                                    }
                                }}>
                                {flag && <Flag flag={flag} type />}
                                <DropdownIcon />
                            </Stack>
                        </mobiscroll.Input>
                    </mobiscroll.Select>
                </Stack> */}
                <DefaultInputStyled
                    value={formItem.value}
                    type="tel"
                    key={formItem.key}
                    typeKey={formItem.key}
                    disabled={formItem.disabled || false}
                    placeholder={formItem.placeholder || ''}
                    onChange={e => {
                        if (onChange) {
                            onChange(formItem, e)
                        } else {
                            if (e.target.value.length === 0) {
                                storeCheckout.SetCheckoutFormValue(formItem.key, '')
                            } else {
                                const regx = get(formItem, 'args.regx', null)
                                if (regx) {
                                    const regex = new RegExp(regx, 'i')
                                    if (regex.test(e.target.value)) {
                                        storeCheckout.SetCheckoutFormValue(formItem.key, e.target.value)
                                    }
                                } else {
                                    storeCheckout.SetCheckoutFormValue(formItem.key, e.target.value)
                                }
                            }
                        }
                    }}
                    InputProps={{
                        autoComplete: 'new-password',
                        autoCorrect: 'off',
                        spellCheck: 'false',
                        startAdornment: (
                            <InputAdornment sx={{ marginRight: '5px', lineHeight: '10px' }} position="start">
                                <Typography variant="label" fontSize={'14px'} fontWeight={'400'} color="#153862">
                                    {storeCheckout.dialCode}
                                </Typography>
                            </InputAdornment>
                        )
                    }}
                    label={null}
                />
            </Stack>
        </Stack>
    )
})

export default MiddleEastAsiaPhoneInput
